/**
 * Asset Cache Default Configuration
 * This file contains default configuration values for the simplified asset cache system
 */

import {
  DEFAULT_CACHE_NAME,
  DEFAULT_CACHE_TTL,
  MAX_CACHEABLE_SIZE,
} from "./constants";
import type { AssetCacheConfig } from "./types";

// ============================================================================
// DEFAULT CONFIGURATION VALUES
// ============================================================================

/**
 * Get default asset cache configuration
 * This provides sensible defaults for all implemented configuration options
 */
export function getDefaultAssetCacheConfig(): Required<AssetCacheConfig> {
  return {
    enabled: true,
    version: "1.0.0",
    debug: false,
    storageName: DEFAULT_CACHE_NAME,
    maxSize: MAX_CACHEABLE_SIZE, // 50 MB
    maxAge: DEFAULT_CACHE_TTL, // 7 days
    serviceWorkerEnabled: true,
    serviceWorkerPath: "/sw.js",
    manifestPath: "/manifest.json",
  };
}
